<template>
    <el-dialog
            :title="title"
            :visible.sync="visible"
            width="50%"
            center>
        <el-form ref="formName" :model="saveModel" :rules="rules" label-width="140px" style="width:80%;margin:0 auto;">
            <br/>
            <el-form-item label="优惠券名称" prop="name">
                <el-input v-model="saveModel.name" placeholder="请输入优惠券名称"></el-input>
            </el-form-item>
            <el-form-item label="优惠券描述" prop="remark">
                <el-input v-model="saveModel.remark" placeholder="请输入优惠券描述"></el-input>
            </el-form-item>
            <el-form-item width="50px" label="优惠券类型" prop="type">
                <el-radio-group v-model="saveModel.type">
                    <el-radio-button :label="item.name" v-for="(item,index) in couponTypes" v-bind:key="index">
                        {{ item.label }}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="有效时间" prop="date" v-if="saveModel.type==='LIMIT_TIME'">
                <el-input-number v-model="saveModel.endDay" :min="1" :precision="0"
                                 placeholder="有效时间" suffix-icon="el-icon-date"></el-input-number>
                天
            </el-form-item>
            <el-form-item width="50px" label="优惠券渠道" prop="channel" size="mini">
                <el-radio-group v-model="saveModel.channel">
                    <el-radio-button :label="item.name" v-for="(item,index) in couponChannels" v-bind:key="index">
                        {{ item.label }}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="指定时间" prop="date" v-if="saveModel.channel==='TIME_LIMIT'">
                {{ saveModel.date }}
                <el-date-picker
                        v-model="date"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"/>
            </el-form-item>

            <el-form-item label="积分" v-if="saveModel.channel==='INTEGRAL'" prop="needIntegral">
                <el-input-number v-model="saveModel.needIntegral" :min="1" placeholder="所需积分"></el-input-number>
            </el-form-item>
            <el-form-item label="商品" prop="offsetAmountMoney" v-if="saveModel.channel==='FIXED_GOODS'">
                <el-tag
                        :key="tag"
                        effect="dark"
                        v-for="tag in dynamicTags"
                        closable
                        :disable-transitions="false"
                        @close="handleClose(tag)">
                    {{ tag }}
                </el-tag>
                <el-tooltip style="margin-left: 10px" content="添加商品" placement="top" effect="light">
                    <el-button size="mini" @click="addGoods" icon="el-icon-plus" circle></el-button>
                </el-tooltip>
            </el-form-item>
            <el-form-item prop="offsetAmountMoney" v-show="saveModel.channel==='WX_SERVICE'">
                <span slot="label">首页图片<br>750*550px</span>
                <Upload :uploadData="uploadData" ref="couponPoster"></Upload>
            </el-form-item>
            <el-form-item label="满" prop="miniPayMoney">
                <el-input-number v-model="saveModel.miniPayMoney" :min="1"
                                 :precision="2"
                                 placeholder="订单金额"></el-input-number>&nbsp;&nbsp;减&nbsp;&nbsp;
                <el-input-number v-model="saveModel.offsetMoney" :min="1" :precision="2"
                                 placeholder="抵用金额"></el-input-number>
            </el-form-item>
            <el-form-item label="状态" prop="offsetAmountMoney">
                <el-switch
                        v-model="saveModel.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="ENABLE"
                        inactive-value="DISABLE"
                >
                </el-switch>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="saveCoupon('formName')">确认</el-button>
                <el-button @click="resetForm('formName')">重置</el-button>
                <el-button @click="visible=false">取消</el-button>
         </span>
    </el-dialog>
</template>

<script>
    import Upload from "@/components/upload";

    export default {
        name: "create-coupon",
        components: {
            Upload
        },
        data() {
            return {
                uploadData: {
                    folder: 'coupon',
                    fileNamePre: 'coupon',
                },
                dynamicTags: ['标签一', '标签二', '标签三'],
                inputVisible: false,
                inputValue: '',
                handleClose(tag) {
                    this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
                },
                title: "制作优惠券",
                visible: false,
                saveModel: {
                    status: 'ENABLE',
                    type: 'NOTE_LIMIT_TIME',
                    channel: 'INTEGRAL',
                },
                rules: {
                    name: [{
                        required: true,
                        message: "请输入商品名称",
                        trigger: "change"
                    }],
                    remark: [{
                        required: true,
                        message: "请输入优惠券描述",
                        trigger: "change"
                    }],
                    miniPayMoney: [{
                        required: true,
                        message: "请输入使用规则",
                        trigger: "change"
                    }], offsetMoney: [{
                        required: true,
                        message: "请输入使用规则",
                        trigger: "change"
                    }],
                    channel: [{
                        required: true,
                        message: "请选择优惠券渠道",
                        trigger: "change"
                    }], type: [{
                        required: true,
                        message: "请选择优惠券类型",
                        trigger: "change"
                    }],
                },
            }
        },
        created() {
            var _this = this;
            _this.couponTypes = _this.$common.enum_config('ECouponType');
            _this.couponChannels = _this.$common.enum_config('ECouponChannel');
        },
        methods: {
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            saveCoupon(formName) {
                var _this = this;
                _this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (_this.saveModel.channel === 'WX_SERVICE' && !_this.$refs.couponPoster.getIconPath().startsWith('http')) {
                            _this.saveModel.homePosterImagePath = _this.$refs.couponPoster.getIconPath();
                        }
                        _this.$common.my_ajax({
                            url: 'coupon/saveCoupon',
                            contentType: 'application/json',
                            data: _this.saveModel,
                            success: function (response) {
                                _this.$message({
                                    message: '保存成功',
                                    type: 'success',
                                    duration: 1000,
                                    onClose: function () {
                                        _this.$emit('success');
                                        _this.visible = false;
                                    }
                                });
                            }
                        });
                    } else {
                        return false;
                    }
                })
            },
            detailCoupon(_couponId) {
                var _this = this;
                _this.$common.my_ajax({
                    url: 'coupon/detailCoupon',
                    data: {
                        couponId: _couponId
                    },
                    success: function (response) {
                        _this.saveModel = response.item;
                        if (_this.saveModel.channel === 'WX_SERVICE') {
                            _this.findCouponPosterImage().then((image => {
                                _this.saveModel.homePosterImagePath = image.value
                                _this.$refs.couponPoster.loadIconPath(config.dynamicResourcePath + image.value)
                            }))
                        }
                        _this.visible = true
                    }
                });
            },
            gotoList() {
                this.$router.push({
                    name: 'couponList',
                });
            },
            openDialog(_couponId) {
                if (_couponId) {
                    this.detailCoupon(_couponId)
                } else {
                    this.visible = true
                }
            },
            findCouponPosterImage() {
                var _this = this;
                return new Promise(function (resolve, rejcet) {
                    _this.$common.my_ajax({
                        url: '/valueConfig/detailValueConfig',
                        data: {
                            valueConfigId: 'coupon_poster'
                        },
                        success(response) {
                            resolve(response.item)
                        }
                    })
                })
            },
        },
        watch: {
            visible: function (newVal, oldVal) {
                if (!newVal) {
                    Object.assign(this.$data, this.$options.data())
                    this.$refs["formName"].clearValidate()
                }
            }
        }
    }
</script>

<style scoped>
    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }

    .el-tag--dark {
        background-color: #409eff;
        border-color: #409eff;
        color: #fff;
        margin-left: 2px;
    }
</style>
